import React, { useState, useEffect } from 'react';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

function EntradaList() {
  const [entradas, setEntradas] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [produto, setProduto] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [fornecedor, setFornecedor] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState('');
  const [notaFiscal, setNotaFiscal] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('access_token');
      const headers = { Authorization: `Bearer ${token}` };
      try {
        const [entradasRes, produtosRes] = await Promise.all([
          api.get('/entradas/', { headers }),
          api.get('/produtos/', { headers }),
        ]);
        setEntradas(entradasRes.data);
        setProdutos(produtosRes.data);
        if (produtosRes.data.length > 0) setProduto(produtosRes.data[0].id);
      } catch {
        toast.error('Erro ao carregar dados.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = localStorage.getItem('access_token');
      const formData = new FormData();
      formData.append('produto', produto);
      formData.append('quantidade', parseInt(quantidade, 10));
      if (fornecedor) formData.append('fornecedor', fornecedor);
      if (notaFiscal) formData.append('nota_fiscal', notaFiscal);

      const res = await api.post('/entradas/', formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEntradas([res.data, ...entradas]);
      setQuantidade('');
      setFornecedor('');
      setNotaFiscal(null);
      e.target.reset();
      toast.success('Entrada registrada com sucesso!');
    } catch {
      toast.error('Erro ao registrar entrada.');
    } finally {
      setSaving(false);
    }
  };

  const nomeProduto = (id) => {
    const p = produtos.find((p) => p.id === id);
    return p ? p.nome : '—';
  };

  const formatDate = (str) => {
    if (!str) return '—';
    return new Date(str).toLocaleDateString('pt-BR');
  };

  const filteredEntradas = entradas.filter((e) => {
    const q = search.toLowerCase();
    return nomeProduto(e.produto).toLowerCase().includes(q) ||
      (e.fornecedor || '').toLowerCase().includes(q);
  });
  const totalPages = Math.ceil(filteredEntradas.length / PAGE_SIZE);
  const paginated  = filteredEntradas.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="produto-page">

      {/* Header */}
      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Entradas de Estoque</h2>
        </div>
      </div>

      {/* Form card */}
      <div className="prd-card prd-form-card">
        <div className="prd-card-accent" />
        <div className="prd-form-body">
          <header className="prd-form-header">
            <h3 className="prd-form-title">Registrar Nova Entrada</h3>
            <p className="prd-form-sub">Informe o produto, quantidade e fornecedor para dar entrada no estoque.</p>
          </header>

          <form onSubmit={handleSubmit}>
            <div className="prd-form-left">
              <div className="prd-form-row3">
                <div className="prd-field">
                  <label className="prd-label">Produto</label>
                  <select
                    className="prd-input"
                    value={produto}
                    onChange={(e) => setProduto(e.target.value)}
                    required
                  >
                    {produtos.map((p) => (
                      <option key={p.id} value={p.id}>{p.nome}</option>
                    ))}
                  </select>
                </div>

                <div className="prd-field">
                  <label className="prd-label">Quantidade</label>
                  <input
                    className="prd-input"
                    type="number"
                    min="1"
                    placeholder="0"
                    value={quantidade}
                    onChange={(e) => setQuantidade(e.target.value)}
                    required
                  />
                </div>

                <div className="prd-field">
                  <label className="prd-label">Fornecedor</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Nome do fornecedor (opcional)"
                    value={fornecedor}
                    onChange={(e) => setFornecedor(e.target.value)}
                  />
                </div>
              </div>

              <div className="prd-field prd-field--full">
                <label className="prd-label">Nota Fiscal (opcional)</label>
                <input
                  className="prd-input"
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => setNotaFiscal(e.target.files[0] || null)}
                  style={{ padding: '6px 10px' }}
                />
              </div>
            </div>

            <div className="prd-form-actions" style={{ gridColumn: 'unset', marginTop: '1.5rem' }}>
              <button type="submit" className="prd-btn-save" disabled={saving || produtos.length === 0}>
                <span className="material-symbols-outlined">arrow_circle_down</span>
                {saving ? 'Registrando...' : 'Registrar Entrada'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* History table */}
      <div className="prd-card prd-table-card">
        <div className="prd-card-accent" />
        <div className="prd-table-toolbar">
          <span className="prd-table-count">Histórico de Entradas</span>
          <div className="produto-search-wrap" style={{ maxWidth: 260 }}>
            <span className="material-symbols-outlined">search</span>
            <input
              type="text"
              placeholder="Buscar produto ou fornecedor..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="prd-table-wrap">
          <table className="prd-table">
            <thead>
              <tr>
                <th>Produto</th>
                <th className="center">Quantidade</th>
                <th>Fornecedor</th>
                <th>Data</th>
                <th className="center">NF</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 4 }).map((__, j) => (
                      <td key={j}><div className="skeleton" /></td>
                    ))}
                  </tr>
                ))
              ) : entradas.length === 0 ? (
                <tr>
                  <td colSpan={5} className="prd-empty">Nenhuma entrada registrada.</td>
                </tr>
              ) : (
                paginated.map((entrada) => (
                  <tr key={entrada.id}>
                    <td>
                      <div className="td-name-wrap">
                        <div className="td-thumb" style={{ background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '16px', color: '#15803d' }}>arrow_circle_down</span>
                        </div>
                        <span className="td-name">{nomeProduto(entrada.produto)}</span>
                      </div>
                    </td>
                    <td className="center td-stock">{entrada.quantidade}</td>
                    <td>{entrada.fornecedor || '—'}</td>
                    <td>{formatDate(entrada.data_entrada)}</td>
                    <td className="center">
                      {entrada.nota_fiscal ? (
                        <a href={entrada.nota_fiscal} target="_blank" rel="noreferrer" title="Ver nota fiscal">
                          <span className="material-symbols-outlined" style={{ fontSize: '18px', color: '#D4AF37', verticalAlign: 'middle' }}>receipt_long</span>
                        </a>
                      ) : '—'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} totalPages={totalPages} onPageChange={(p) => { setPage(p); window.scrollTo(0, 0); }} />
      </div>
    </div>
  );
}

export default EntradaList;
